<template>
  <div id="app">
    <Header/>
    <router-view />
    <Footer/>
    <div id="opening" class="opening">
      <audio id="sound" volume="2" style="visibility: hidden">
        <source src="img/song_2.wav" type="audio/mpeg">
      </audio>
      <img  width="80%" src="img/logo_giant.png" alt="">
    </div>
  </div>
</template>
<script>
  import Header from "./components/Header";
  import Footer from "./components/Footer";

  export default {
    components: {
      Header, Footer
    },
    mounted() {
      // let audio = new Audio('/img/sound.mp3');
      this.Open()
    },
    methods:{
      Open(){
        let audio = document.getElementById('sound');
        audio.pause()
        audio.play();
  
        setTimeout( function(){
          document.getElementsByClassName('opening')[0].style.display='none';
        },3000)
  
        setTimeout(function(){audio.pause()},3200)
      }
    }
  
  }
</script>
<style lang="scss">
  body{
    background: #232323;
  margin:0;
  }
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}
.opening {
  background: black;
  position: absolute;
  z-index: 1000;
  height: 100vh;
  padding: 0;
  margin: 0;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
 img{
   animation: logo 3s linear ;
 }
}
  @keyframes logo {
    0%   { width: 50%; }
    100%   { width: 80%; }
  }
</style>
